import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _SortDown(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2, d: "M5 7h8M5 12h6M5 17h4" }),
            React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "m16 15 3 3 3-3m-3 3V6" })));
}
const SortDown = forwardRef(_SortDown);
export { SortDown };
